import { render, staticRenderFns } from "./ModalTerritorioAdicionadoAR.vue?vue&type=template&id=3da69a06&lang=pug"
import script from "./ModalTerritorioAdicionadoAR.vue?vue&type=script&lang=js"
export * from "./ModalTerritorioAdicionadoAR.vue?vue&type=script&lang=js"
import style0 from "./ModalTerritorioAdicionadoAR.vue?vue&type=style&index=0&id=3da69a06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports